"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InPageJumpNavIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const InPageJumpNavIcon = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "a",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.442.5H.558A.558.558 0 000 1.058v13.884c0 .308.25.558.558.558h18.884c.308 0 .558-.25.558-.558V1.058A.558.558 0 0019.442.5zm-.275 14.167H.833V4.033h18.334v10.634zm0-11.467H.833V1.333h18.334V3.2z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.442.5H.558A.558.558 0 000 1.058v13.884c0 .308.25.558.558.558h18.884c.308 0 .558-.25.558-.558V1.058A.558.558 0 0019.442.5zm-.275 14.167H.833V4.033h18.334v10.634zm0-11.467H.833V1.333h18.334V3.2z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.167 14.667v1h1v-1h-1zm-18.334 0h-1v1h1v-1zm0-10.634v-1h-1v1h1zm18.334 0h1v-1h-1v1zm0-.833v1h1v-1h-1zM.833 3.2h-1v1h1v-1zm0-1.867v-1h-1v1h1zm18.334 0h1v-1h-1v1zM19.442-.5H.558v2h18.884v-2zM.558-.5C-.302-.5-1 .198-1 1.058h2a.442.442 0 01-.442.442v-2zM-1 1.058v13.884h2V1.058h-2zm0 13.884c0 .86.698 1.558 1.558 1.558v-2c.244 0 .442.198.442.442h-2zM.558 16.5h18.884v-2H.558v2zm18.884 0c.86 0 1.558-.698 1.558-1.558h-2c0-.244.198-.442.442-.442v2zM21 14.942V1.058h-2v13.884h2zm0-13.884C21 .198 20.302-.5 19.442-.5v2A.442.442 0 0119 1.058h2zm-1.833 12.609H.833v2h18.334v-2zm-17.334 1V4.033h-2v10.634h2zm-1-9.634h18.334v-2H.833v2zm17.334-1v10.634h2V4.033h-2zm1-1.833H.833v2h18.334v-2zm-17.334 1V1.333h-2V3.2h2zm-1-.867h18.334v-2H.833v2zm17.334-1V3.2h2V1.333h-2z",
    fill: "currentColor",
    mask: "url(#a)"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "b",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 7.166h6.337a.417.417 0 000-.833H2.715a.417.417 0 000 .833z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 7.166h6.337a.417.417 0 000-.833H2.715a.417.417 0 000 .833z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 8.166h6.337v-2H2.715v2zm6.337 0c.783 0 1.417-.634 1.417-1.416h-2c0-.322.261-.584.583-.584v2zM10.47 6.75c0-.783-.634-1.417-1.417-1.417v2a.583.583 0 01-.583-.583h2zM9.052 5.333H2.715v2h6.337v-2zm-6.337 0c-.783 0-1.417.634-1.417 1.417h2a.583.583 0 01-.583.583v-2zM1.298 6.75c0 .782.634 1.416 1.417 1.416v-2c.322 0 .583.262.583.584h-2z",
    fill: "currentColor",
    mask: "url(#b)"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "c",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 9.666h14.671a.416.416 0 100-.833H2.715a.417.417 0 100 .833z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 9.666h14.671a.416.416 0 100-.833H2.715a.417.417 0 100 .833z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 10.666h14.671v-2H2.715v2zm14.671 0c.783 0 1.417-.634 1.417-1.416h-2c0-.322.261-.584.583-.584v2zm1.417-1.416c0-.783-.634-1.417-1.417-1.417v2a.584.584 0 01-.583-.583h2zm-1.417-1.417H2.715v2h14.671v-2zm-14.671 0c-.782 0-1.417.634-1.417 1.417h2a.583.583 0 01-.583.583v-2zM1.298 9.25c0 .783.635 1.416 1.417 1.416v-2c.322 0 .583.261.583.584h-2z",
    fill: "currentColor",
    mask: "url(#c)"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "d",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 12.166h14.671a.416.416 0 100-.833H2.715a.417.417 0 100 .833z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 12.166h14.671a.416.416 0 100-.833H2.715a.417.417 0 100 .833z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.715 13.166h14.671v-2H2.715v2zm14.671 0c.783 0 1.417-.634 1.417-1.416h-2c0-.322.261-.584.583-.584v2zm1.417-1.416c0-.783-.634-1.417-1.417-1.417v2a.584.584 0 01-.583-.583h2zm-1.417-1.417H2.715v2h14.671v-2zm-14.671 0c-.782 0-1.417.634-1.417 1.417h2a.583.583 0 01-.583.583v-2zM1.298 11.75c0 .783.635 1.416 1.417 1.416v-2c.322 0 .583.261.583.584h-2z",
    fill: "currentColor",
    mask: "url(#d)"
  }));
};
exports.InPageJumpNavIcon = InPageJumpNavIcon;